/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomSeparator from '../../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../../../SharedModules/Errors/SuccessMessage';
import Spinner from '../../../../../SharedModules/Spinner/Spinner';
import {
  getAllNDCReferenceData,
  getGeneralsystemparameterDetails,
  setNDCSuccessMessage,
} from '../../store/action';
import NDCDetailsHeaderDetailsComponent, {
  getNDCValue,
} from './NDCDetailsHeaderDetailsComponent';
import NDCDetailsPagination from './NDCDetailsPagiantion';
import NDCDetailsTabSection from './NDCDetailsTabSection';
import { handleScrollToEvent } from '../../../../../SharedModules/CommonUtilities/commonUtilities';

const NDCDetailsComponent = () => {
  const dispatch = useDispatch();
  const [fullScreen, setFullScreen] = useState(false);

  const currentNDCDetailsSelected = useSelector(
    (state) => state.sharedState.ndc.currentNDCDetailsSelected
  );

  const errorPopupMessage = useSelector(
    (state) => state.sharedState.ndc.errorPopupMessage
  );
  const successMessage = useSelector(
    (state) => state.sharedState.ndc.successMessage
  );
  const loading = useSelector((state) => state.sharedState.ndc.loading);

  // useEffect(() => {
  
  //   let interval;

    // if (successMessage) {
    //   // interval = setTimeout(() => {
    //     // dispatch(setNDCSuccessMessage(null));
    //   // }, 25000);
    // }

    // return () => {
    //   if (interval) {
    //     clearTimeout(interval);
    //   }
    // };
  // }, [successMessage]);

  useEffect(() => {
    handleScrollToEvent();
    dispatch(getAllNDCReferenceData());
    dispatch(getGeneralsystemparameterDetails());
    return () => {
      dispatch(setNDCSuccessMessage(null));
    };
  }, []);

  useEffect(() => {
    if (currentNDCDetailsSelected) {
      const ele = document.querySelector('.nav-item-active a .tab-title');
      if (ele) {
        ele.textContent = `NDC Details [${getNDCValue(
          currentNDCDetailsSelected
        )}]`;
      }
    }
  }, [currentNDCDetailsSelected]);

  useEffect(()=>{
  if(fullScreen){
    dispatch(setNDCSuccessMessage(null));
  }
  },[fullScreen])

  return (
    <>
      <div className="ndc tabs-container custom-check">
        {loading && <Spinner load={loading} />}
        <div className="mt-3 container px-0 mw-100">
          {successMessage && (
            <div className="mt-3 col-12 p-0">
              <DisplaySuccessMessages successMessages={[successMessage]} />
            </div>
          )}
          {errorPopupMessage && (
            <div className="mt-3 col-12 p-0">
              <DisplayErrorMessages errorMessages={[errorPopupMessage]} />
            </div>
          )}

          <CustomSeparator
            parent1="Display"
            parent2={getNDCValue(currentNDCDetailsSelected)}
          />

          {!fullScreen && <NDCDetailsPagination />}
          {!fullScreen && (
            <NDCDetailsHeaderDetailsComponent
              currentNDCDetailsSelected={currentNDCDetailsSelected}
            />
          )}
        </div>
        <div className="tab-body mt-3 d-flex flex-column">
          <NDCDetailsTabSection
            fullScreen={fullScreen}
            setFullScreen={setFullScreen}
          />
        </div>
      </div>
    </>
  );
};

export default NDCDetailsComponent;
